import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  getFirstContactForAccountAction,
  getFirstContactForAccountFailureAction,
  getFirstContactForAccountSuccessAction
} from './get-first-contact-for-account.actions';
import { GetFirstContactForAccountService } from './get-first-contact-for-account.service';

@Injectable()
export class GetFirstContactForAccountEffects {
  getFirstContactForAccount$ = createEffect(() => this.actions$.pipe(
    ofType(getFirstContactForAccountAction),
    switchMap(action =>
      this.getFirstContactForAccountService.get(action.payload.accountId).pipe(
        map(data => getFirstContactForAccountSuccessAction({ data })),
        catchError(error => of(getFirstContactForAccountFailureAction({ error }))),
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private getFirstContactForAccountService: GetFirstContactForAccountService,
  ) {
  }
}
